import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

let dark = true;
try {
  const saved = window.localStorage.getItem("defor-theme");
  if (saved === "light") dark = false;
  else if (saved === "dark") dark = true;
} catch (_) {
  // localStorage unavailable (private mode, etc.) — fall back to default
}

export default new Vuetify({
  theme: { dark },
});
